interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/60c09a59e0fb28552f21c009d5db8614/9d6b92f26044a717beee1d11c21ed422.png" 
              alt="Recover Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-2xl font-serif text-[#2F7FB7] font-semibold">RECOVER</span>
            <div className="w-2 h-2 rounded-full bg-[#5A9FD4] animate-pulse ml-1"></div>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className="text-sm text-[#4A5568] hover:text-[#2F7FB7] transition-colors cursor-pointer whitespace-nowrap">
              About
            </button>
            <button onClick={() => scrollToSection('features')} className="text-sm text-[#4A5568] hover:text-[#2F7FB7] transition-colors cursor-pointer whitespace-nowrap">
              Features
            </button>
            <button onClick={() => scrollToSection('masterclass')} className="text-sm text-[#4A5568] hover:text-[#2F7FB7] transition-colors cursor-pointer whitespace-nowrap">
              Masterclass
            </button>
            <button onClick={() => scrollToSection('resources')} className="text-sm text-[#4A5568] hover:text-[#2F7FB7] transition-colors cursor-pointer whitespace-nowrap">
              Resources
            </button>
          </div>

          <a href="/download" className="bg-[#2F7FB7] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#1E5A8E] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap">
            Download App
          </a>
        </div>
      </div>
    </nav>
  );
}
